import { ThisConnector } from '../../../../api/connector'

export async function getTeamserverUrl(this: ThisConnector) {
  const data = await this.connector.get(`/global/properties`)
  return data?.teamserver_url
}
